export default __webpack_public_path__ + "static/step21-62130af5a92fe4df656aa28776e0d7a1.png";